import { themed } from "@smartsheet/sds-theme-internal";

export const clickableTheme = themed({
    borderRadius: {
        "lodestar-light": "1px",
        "ursa-light": "2px",
    },
} as const);
